import React, { useState, useEffect } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Box,
    Stack,
    FormControl,
    Autocomplete,
    TextField,
    Typography,
    TablePagination,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from "dayjs";
import { ApiGetClients, ApiGetClientEntities, ApiGetSpentReport, ApiGetClientDbName } from "../../../apiService/Core/Apicall.tsx";
import { AlignRight } from "lucide-react";

interface ClientType {
    clientId: number;
    clientName: string;
}
interface ClientEntity {
    clientEntityId: number;
    entityName: string;
}
const SpentReport: React.FC = () => {
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().startOf('year'));
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [clients, setClients] = useState<any>([]);
    const [clientEntities, setClientEntities] = useState<ClientEntity[]>([]);
    const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);
    const [selectedClient, setSelectedClient] = useState<ClientType | null>(null);
    const [reportData, setReportData] = useState<any[]>([]);
    const [clientGroups, setClientGroups] = useState<any[]>([]);
    const [selectedGroupDbName, setSelectedGroupDbName] = useState<any | null>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [datalength, setdatalength] = useState<any>(null);



    useEffect(() => {
        const getclientgroupName = async () => {

            try {
                const res = await ApiGetClientDbName()
                setClientGroups(res.data)
                setSelectedGroupDbName(res.data.find(item => item.clientGroupName === "MM"))

            } catch (error) {
                alert(error)
            }
        }
        getclientgroupName()
    }, [])

    useEffect(() => {
        const getclients = async () => {
            if (selectedGroupDbName) {

                try {
                    const query = `?status=active&clientGroup=${selectedGroupDbName.clientGroupName}`;
                    const res = await ApiGetClients(query)
                    const mappedClients = res.data.map((client: any) => ({
                        clientId: client.ClientID,
                        clientName: client.ClientName,
                    }));

                    setClients(mappedClients);
                    setSelectedClient(mappedClients[0])

                } catch (error) {
                    alert(error)
                }
            }
        }
        getclients()
    }, [selectedGroupDbName])

    useEffect(() => {
        const getcliententities = async () => {
            if (selectedClient) {
                const data = `?clientId=${selectedClient.clientId}`
                try {
                    const res = await ApiGetClientEntities(data)
                    setClientEntities(res.data)
                    setSelectedEntityId(res.data[0].clientEntityId)
                } catch (error) {
                    alert(error)
                }
            }
        }
        getcliententities()
    }, [selectedClient])
    console.log("selected entity", selectedEntityId)

    const handleClientChange = (event: any, value: ClientType | null) => {
        setSelectedClient(value);
        setClientEntities([]);
        setSelectedEntityId(null);
        setReportData([]);
        // if (value?.clientId) {
        //     ApiGetClientEntities(`?clientId=${value.clientId}`)
        //         .then((res: any) => {
        //             if (res?.data) {
        //                 setClientEntities(res.data);
        //             }
        //         })
        //         .catch((err: any) => {
        //             console.error("Failed to fetch client entities", err);
        //         });
        // }
    };

    useEffect(() => {
        getspentreport()

    }, [selectedEntityId, startDate, endDate]);

    const getspentreport = async () => {
        setReportData([]);
        const formattedStartDate = startDate ? startDate.format('M/YYYY') : '';
        const formattedEndDate = endDate ? endDate.format('M/YYYY') : '';
        if (selectedEntityId && formattedStartDate && formattedEndDate) {
            const data = `?clientEntityId=${selectedEntityId}&startMonth=${formattedStartDate}&EndMonth=${formattedEndDate}`
            try {
                const res = await ApiGetSpentReport(data)
                setReportData(res.data)
                setdatalength(res.dataCount)
            } catch (error) {
                console.log(error);
            }
        }
    }


    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <Box className="manage-admin-container" padding='20px'>
            <Box sx={{ width: "100%", mt: 1}}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "0px",
                }}>
                    <Typography variant="h3" className="common-manage-h1 mb-3" sx={{
                        textAlign: "center",
                        flexGrow: 1,
                        // ml: "200px"
                    }}>
                        Yearly Report
                    </Typography>
                    <Box sx={{
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>

                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "-59px",
                        marginTop: "21px",
                    }}
                >
                   
                    <Stack direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180, mb: 0 }}>
                            <Autocomplete
                                disablePortal
                                id="group-autocomplete"
                                options={clientGroups}
                                value={selectedGroupDbName}
                                getOptionLabel={(option: any) => option.clientGroupName || ""}
                                isOptionEqualToValue={(option: any, value: any) => option.clientGroupDBName === value.clientGroupDBName}
                                onChange={(event, value) => {
                                    setSelectedGroupDbName(value ? value.clientGroupName : null);
                                    setClientEntities([]);
                                    setSelectedEntityId(null);
                                    setReportData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client Group" />
                                )}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clients}
                                value={selectedClient}
                                getOptionLabel={(option: ClientType) => option.clientName}
                                isOptionEqualToValue={(option, value) => option.clientId === value.clientId}
                                onChange={handleClientChange}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 185 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={clientEntities}
                                getOptionLabel={(option: any) => option.entityName}
                                value={clientEntities.find((entity) => entity.clientEntityId === selectedEntityId) || null}
                                onChange={(event: any, value: ClientEntity | null) => {
                                    setSelectedEntityId(value?.clientEntityId || null);
                                    setReportData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" sx={{ backgroundColor: "#75724C", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}>
                            DOWNLOAD AS XLSX
                        </Button>
                        <Button variant="contained" sx={{ backgroundColor: "#75724C", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}>
                            DOWNLOAD AS PDF
                        </Button>
                    </Stack>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px",
                    mb: 2
                }}
            >
                <Box display="flex" alignItems="center" gap={2} marginLeft={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={['year', 'month']}
                            label="Start Month"
                            openTo="month"
                            value={startDate}
                            onChange={(newValue) => {
                                setStartDate(newValue);
                                if (!newValue) {
                                    setEndDate(null);
                                }
                            }}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    sx: {
                                        width: 180,
                                        '& .MuiInputBase-root': { height: 40 }
                                    }
                                }
                            }}
                        />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={['year', 'month']}
                            label="End Month"
                            openTo="month"
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            minDate={startDate || undefined}
                            disabled={!startDate}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    sx: {
                                        width: 180,
                                        '& .MuiInputBase-root': { height: 40 }
                                    }
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>
            {selectedEntityId && startDate && endDate && (
                <>

                    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                        <TableHead>
                            <TableRow className="table-row-background">
                                <TableCell style={{ width: '20%', color: "#fff", fontWeight: "bold", textAlign: "left" }}>Group Name</TableCell>
                                <TableCell style={{ width: '20%', color: "#fff", fontWeight: "bold", textAlign: "left" }}>Venue / Store Name</TableCell>
                                <TableCell style={{ width: '5%', color: "#fff", fontWeight: "bold", textAlign: "center" }}>Month</TableCell>
                                <TableCell style={{ width: '20%', color: "#fff", fontWeight: "bold", textAlign: "start" }}>Type</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Food</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Bar</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Gaming</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Bottle Shop</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Total Spent</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportData?.length > 0 ? reportData.map((report: any, index: number) => (
                                <TableRow>
                                    <TableCell style={{ textAlign: "left" }}>{report.clientName}</TableCell>
                                    <TableCell style={{ textAlign: "left" }}>{report.venueName}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.reportMonth}/{report.reportYear}</TableCell>
                                    <TableCell style={{ textAlign: "start" }}>{report.shopTypeName}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentFoodAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentBarAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentBottleShopAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentGamingAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.totalSpent}</TableCell>
                                </TableRow>
                            )) : <TableRow><TableCell colSpan={9} className="text-center"><Typography>No Data Found </Typography></TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={datalength}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </>


            )}
        </Box>
    );
};

export default SpentReport;